var YouLi = YouLi ? YouLi : {};
YouLi.Validation = YouLi.Validation ? YouLi.Validation : {};

(function (YouLi) {
    (function (Validation) {

        YouLi.Validation.IsValidFileType = function (file, validFileTypes) {

            const fileExtension = YouLi.Common.Utils.GetFileExtension(file.name);
            let mimeType = YouLi.Common.Utils.MimeType(fileExtension);

            if (file.type)
                mimeType = file.type;   // override if we can (some Windows browsers don't work with this for types like CSV - YOULI-3250)

            return validFileTypes.includes(mimeType);
        }

        /**
         * Initializes form validation for the specified forms.
         * @param {string|jQuery} formSelector - A CSS selector string or jQuery object used to select forms for validation.
         *                                      If not provided, defaults to selecting all forms ("form").
         */
        YouLi.Validation.Init = function (formSelector) {

            // Define reusable highlight/unhighlight handlers
            function highlight(element) {
                $(element).closest('.form-group').addClass('has-error');
                $(element).addClass('input-validation-error');
            }

            function unhighlight(element) {
                $(element).closest('.form-group').removeClass('has-error');
                $(element).removeClass('input-validation-error');
            }

            // Australian date validation (browser validation in Chrome will fail without this)
            $.validator.methods.date = function (value, element) {
                return this.optional(element) || moment(value, "DD/MM/YYYY") || moment(value, "D MMM YYYY");
            };

            $.validator.setDefaults({
                highlight: highlight,
                unhighlight: unhighlight,
                ignore: ":hidden:not([data-force-val='true'])"   // do not ignore hidden fields if they have a special flag set
            });

            // ALSO apply highlight/unhighlight to the existing form validator instance
            var form = $(formSelector || "form"); // default to all forms if not specified
            form.each(function () {
                var validator = $(this).data("validator");
                if (validator) {
                    validator.settings.highlight = highlight;
                    validator.settings.unhighlight = unhighlight;
                }
            });
        }

    }(YouLi.Validation ? YouLi.Validation : {}));
}(YouLi ? YouLi : {}));

(function ($) {

   
}(jQuery));
